export default {
  views: {
    login: {
      subtitle: '個人団体予約お申込みサイト',
      testAccount: {
        individual: '個人ユーザー'
      }
    },
    register: {
      subtitle: '個人団体予約お申込み',
      sectionTitle: '新規ユーザ登録',
      createAccount: 'アカウントを作成する',
      successMessage:
        '新規ユーザー登録メールを{{email}}に送信しました。メールをご確認ください。'
    },
    accountCreate: {
      title: '新規アカウント登録',
      tips: '下記の情報登録をお願いいたします。',
      name: '氏名',
      nameKana: '氏名（フリガナ）',
      email: 'メールアドレス（ログインID）',
      faxNumber: 'FAX番号',
      phone: '電話番号',
      terms: '利用規約',
      agree: 'に同意する',
      termsAgreeOk: '同意する',
      sendEmailVerification:
        'パスワード再設定用のURLが{{email}}に送信しました。メールをご確認の上、パスワードを設定してからログインしてください。'
    },
    agency: {
      agency: '個人団体名',
      placeholder: {
        agencyOfficeContactName: '個人団体・担当者名'
      }
    }
  }
};
